<template>
    <div class="component-invoice" v-if="internalValue">

      <h1>{{ title }}</h1>
      <h1>{{ subtitle }}</h1>

      <div class="invoice-table">
        <div class="invoice-table-header">
          <div class="picture"></div>
          <div>Libellé</div>
          <div>Quantité</div>
          <div style="text-align: center;">Rabais</div>
          <div class="total">Total {{ price }}</div>
        </div>
        <div v-for="item in internalValue.products">
          <div class="invoice-table-line picture">
            <img :src="item.picture" width="80" style="float:left;margin-right: 0px;margin-bottom: 0px;"/>
          </div>
          <div class="invoice-table-line name">
            <strong>{{ item.name }}</strong>
            <p class="ean sku" v-if="item.ean || item.sku">{{ item.ean || item.sku }}</p>
            <p class="description" v-if="item.description">{{ item.description }}</p>
            <p v-for="schedule in item.schedules" style="color:rgba(var(--color-main), 1);">
              <span v-if="schedule"><schedule :start-at="schedule.schedule_start_at" :end-at="schedule.schedule_end_at"></schedule></span>
            </p>
            <p style="color:rgba(var(--color-main), 1);font-weight:500;" v-if="item.has_schedule && countEmptySchedules(item.schedules) > 0">{{ countEmptySchedules(item.schedules) }} rendez-vous restant(s) à placer</p>
            <ul v-if="item.options && item.options.length" style="margin-top: 1em;list-style: square;margin-left: 1em;">
              <li v-for="option in item.options">{{ option.name }}: {{ option.value }}</li>
            </ul>
            <p class="gift" v-if="item.has_gift"><i class="icon icon-icon_heart"></i> Emballage cadeau</p>
            <div v-if="item.delivery_notes.length" style="margin-top: 1em;">
              <div v-for="dn in item.delivery_notes" style="display: flex; align-items: center;">
                <icon name="package-check"/> <span style="margin-left: 0.5em;">{{ dn.reference }} <br>Contient {{ dn.pivot.quantity }} pièce(s)</span>
              </div>
            </div>
          </div>
          <div class="invoice-table-line quantity">
            <span v-if="!item.is_forfait">{{ item.quantity }} x {{ item.amount_base_ht|formatNumber }}</span>
            <span v-else>Forfait</span>
          </div>
          <div class="invoice-table-line discount" style="text-align: center;">
            <span>{{ item.discount_percentage.toFixed(2) }}%</span>
          </div>
          <div class="invoice-table-line total">
            <span>{{ currency }} {{ (item.quantity * item.amount_ht)|formatNumber }}</span>
          </div>
        </div>
      </div>

      <div class="invoice-table-footer">
        <div class="subtotal">
          <div class="invoice-table-line">Sous-total</div>
          <div class="invoice-table-line total"><span>{{ currency }} {{ internalValue.amount_subtotal_ht|formatNumber }}</span></div>
        </div>

        <div class="shipping" v-if="internalValue.shipping">
          <div class="invoice-table-line">{{ internalValue.shipping.name }}</div>
          <div class="invoice-table-line">
            <span>{{ currency }} {{ internalValue.amount_shipping_ht|formatNumber }}</span>
          </div>
        </div>

        <div class="vouchers" v-for="voucher in internalValue.vouchers">
          <div class="invoice-table-line">{{ voucher.name }} / {{ voucher.token }}</div>
          <div class="invoice-table-line">
            <span>{{ currency }} - {{ Math.abs(voucher.amount.ht)|formatNumber }}</span>
          </div>
        </div>

        <div class="tax" v-for="tax in internalValue.taxes" v-if="tax.percentage > 0 && tax.amount > 0">
          <div class="invoice-table-line">Taxes {{ tax.percentage }}%</div>
          <div class="invoice-table-line">
            <span>{{ currency }} {{ tax.amount|formatNumber }}</span>
          </div>
        </div>

        <div class="total">
          <div class="invoice-table-line">Total en {{ currency }}</div>
          <div class="invoice-table-line total">
            <span>{{ currency }} {{ internalValue.amount_total|formatNumber }}</span>
          </div>
        </div>
      </div>

    </div>

</template>

<script>

    export default {
        props: ['value','title','subtitle'],
        components: {
        },
        data: function () {
            return {
                internalValue: [],
                currency: 'CHF',
                price: 'HT',
            }
        },
        created: function() {
            this.internalValue = this.value
            this.currency = this.value.currency && this.value.currency.id ? this.value.currency.id : this.value.currency
        },
        methods: {
          countEmptySchedules: function(schedules){
            let count = 0;
            for (let item of schedules) {
              if( item === null ){
                count+=1;
              }
            }
            return count;
          }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Invoice.vue